import PropTypes from "prop-types";
import styles from "./RightWrap.module.css";

const RightWrap = (props) => {
  return <div className={styles.rightWrap}>{props.children}</div>;
};

RightWrap.propTypes = {
  children: PropTypes.node,
};

export default RightWrap;
